import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Credits } from '../models/credits';
import { compare } from 'fast-json-patch';
import { CreditAlerts } from '../models/credit-alerts';

@Injectable({
  providedIn: 'root'
})
export class CreditsService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getUserCredits(): Observable<Credits> {
    return this.http.get<Response>(this.baseUrl + 'credits').pipe(map(data => Credits.deserialize(data)));
  }

  getCreditsAlerts(): Observable<CreditAlerts> {
    return this.http.get<Response>(this.baseUrl + 'alerts').pipe(map(data => CreditAlerts.deserialize(data)));
  }

  public updateCreditsAlerts(previousCreditAlerts: CreditAlerts, alertsToSave: CreditAlerts): Observable<CreditAlerts> {
    const alertsPatch = compare(previousCreditAlerts, alertsToSave);
    const patchHeaders = new HttpHeaders().set('Content-type', 'application/json-patch+json');
    return this.http
      .patch<Response>(this.baseUrl + 'alerts', alertsPatch, { headers: patchHeaders })
      .pipe(map(data => CreditAlerts.deserialize(data)));
  }
}
